
const CmdReadFileList = require("./cmd_read_file_list")
module.exports = {
    100100: { format: '<BBB100A', type: CmdReadFileList, order_map: [0, 1, 2, 3], crc_extra: 250 },
}
